"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Dropdown_1 = require("../Dropdown");
var helpers_1 = require("../../helpers");
var useControlState_1 = require("../helpers/useControlState");
var Suggest_1 = require("../../Suggest");
var defaultControlRenderer_1 = require("./controls/defaultControlRenderer");
var getStylesWithMaxWidth_1 = require("../../helpers/getStylesWithMaxWidth");
var public_1 = require("../../common/public");
exports.SelectableTextInput = helpers_1.createUIElement('SelectableTextInput', function (_a, ref) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? public_1.CONTROL_SIZE.s : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, data = _a.data, value = _a.value, hasEnterKeyStopPropagation = _a.hasEnterKeyStopPropagation, placeholder = _a.placeholder, onChange = _a.onChange, _e = _a.optionContainerRenderer, optionContainerRenderer = _e === void 0 ? Suggest_1.createOptionContainerRenderer() : _e, onMenuOpen = _a.onMenuOpen, onMenuClose = _a.onMenuClose, isOptionDisabled = _a.isOptionDisabled, virtualListWidth = _a.virtualListWidth, virtualListLimit = _a.virtualListLimit, preventInputValue = _a.preventInputValue, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "size", "disabled", "error", "data", "value", "hasEnterKeyStopPropagation", "placeholder", "onChange", "optionContainerRenderer", "onMenuOpen", "onMenuClose", "isOptionDisabled", "virtualListWidth", "virtualListLimit", "preventInputValue", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var dataSelectorId = rest['data-selector-id'] || 'selectable-text-input';
    var rootRef = react_1.useRef(null);
    var inputRef = ref || rootRef;
    var _f = useControlState_1.useControlState({
        rootRef: inputRef,
        onBlur: onBlur,
        onFocus: onFocus
    }), focused = _f.focused, active = _f.active, activate = _f.activate, preventBlur = _f.preventBlur, input = _f.input;
    var selectedIndex = value ? data.indexOf(value) : -1;
    var control = Dropdown_1.useDropdown({
        offset: 1,
        renderControl: function (_a) {
            var button = _a.button, dropdownActions = _a.actions, isActive = _a.isActive;
            var actions = {
                open: function () {
                    if (disabled || isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.show();
                    activate();
                },
                close: function () {
                    if (disabled || !isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.hide();
                    activate();
                }
            };
            return defaultControlRenderer_1.createDefaultControl({ inputRef: inputRef })(__assign(__assign({}, rest), { className: "vm-SelectableTextInput " + className, testId: dataSelectorId, error: !!error, size: size, disabled: !!disabled, active: active, opened: isActive, actions: actions,
                focused: focused, value: value || '', hasEnterKeyStopPropagation: hasEnterKeyStopPropagation,
                placeholder: placeholder, control: {
                    ref: button.ref,
                    preventInputValue: preventInputValue,
                    onChange: onChange,
                    onBlur: input.onBlur,
                    onFocus: input.onFocus,
                    onKeyDown: function (e) {
                        actions.close();
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    },
                    onMouseDown: function (e) {
                        e === null || e === void 0 ? void 0 : e.stopPropagation();
                        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                    },
                    onMouseUp: onMouseUp,
                    onClick: onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onKeyUp: onKeyUp,
                    onKeyPress: onKeyPress,
                    style: style
                } }));
        },
        renderPopover: function (_a) {
            var actions = _a.actions, popover = _a.popover;
            var suggestStyle = getStylesWithMaxWidth_1.getStylesWithMaxWidth(popover.style);
            var suggestVirtualListWidth = virtualListWidth ||
                (typeof (suggestStyle === null || suggestStyle === void 0 ? void 0 : suggestStyle.minWidth) === 'number'
                    ? suggestStyle === null || suggestStyle === void 0 ? void 0 : suggestStyle.minWidth : undefined);
            return (react_1.default.createElement(Suggest_1.Suggest, { "data-selector-id": dataSelectorId + "-menu", ref: popover.ref, selectedIndex: selectedIndex, textGetter: function (item) { return item; }, onSelect: function (item, idx) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(item);
                    actions.hide();
                }, onMouseDown: preventBlur, optionContainerRenderer: optionContainerRenderer, isOptionDisabled: isOptionDisabled, data: data, style: suggestStyle, hasVirtualization: true, virtualListWidth: suggestVirtualListWidth, virtualListLimit: virtualListLimit }));
        },
        onDidHide: onMenuClose,
        onDidShow: onMenuOpen,
        dropdownWidth: Dropdown_1.DROPDOWN_WIDTH.minControlWidthAndMaxXXL
    })[0];
    return control;
});
//# sourceMappingURL=SelectableTextInput.js.map